
// import sysRoute from "./sysRoute";
// import yxRoute from "./yxRoute";

const staticRoutes = [
    {
        path: '/',
        redirect: 'login'
    },
    {
        path: '/login',
        component: () => import(/* webpackChunkName: 'login' */ '../page/login')
    },
    {
        path: '/test',
        component: () => import(/* webpackChunkName: 'login' */ '../page/test')
    },
    {
        path: '/error',
        component: () => import('../page/error'),
        children: [
            {
                path: '401',
                component: () => import('../page/error/401')
            },
            {
                path: '404',
                component: () => import('../page/error/404')
            },
            {
                path: '500',
                component: () => import('../page/error/500')
            }
        ]
    },
    {
        path: '/management',
        name: 'management',
        component: () => import(/* webpackChunkName: 'home' */ '../page/management'),
        // children: [...yxRoute, ...sysRoute]
        // children: [
        //     {
        //         path: '/home',
        //         redirect: yxRoute[0].path,
        //         component: () => import('../page/home/index.vue'),
        //     },
        //     {
        //         path: '/sys/users/modifyPwd',
        //         component: () => import(/* webpackChunkName: 'login' */ '../page/management/sys/users/modifyPwd')
        //     },
        //     ...yxRoute, ...sysRoute
        // ]
    },
];

export default staticRoutes;